import React from 'react'
import convert from 'htmr'
import PropTypes from 'prop-types'

const transform = {
  b: ({ children }) => <strong className="font-bold">{children}</strong>,
  a: ({ children, href }) => {
    return (
      <a
        href={href}
        className="border-b-1 border-blue-dark text-blue-dark transition hover:border-Type hover:text-Type"
      >
        {children}
      </a>
    )
  },
}

export default function CalloutBlock({ text }) {
  return (
    <div className="mb-32 rounded-8 bg-green-light p-24 text-black md:mx-56 md:mb-48 md:mt-64 md:p-36 lg:mx-72 lg:px-48">
      {convert(text, { transform })}
    </div>
  )
}

CalloutBlock.propTypes = {
  text: PropTypes.string.isRequired,
}
